import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=df231a6e&scoped=true&"
import script from "./Badge.vue?vue&type=script&lang=ts&"
export * from "./Badge.vue?vue&type=script&lang=ts&"
import style0 from "./Badge.vue?vue&type=style&index=0&id=df231a6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df231a6e",
  null
  
)

export default component.exports